<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view v-wechat-title="$route.meta.title+'-瘦西湖发票系统'"></router-view>
    </transition>
    <tab></tab>
  </div>
</template>
<script>
import tab from './components/tab'
export default {
  name: 'app',
  components: {
    tab
  },
  created () {
    this.isWx()
  },
  data () {
    return {
      transitionName: 'slide-left'
    }
  },
  methods: {
    isWx () {
      const bol = (function () { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 })()
      this.$store.commit('changeIsWx', bol)
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  }
}
</script>
<style>
  body {
    background-color: #f2f2f2;
  }
  html,body{
    width: 100%;
    height: 100%;
  }
  #app{
    width: 100%;
  }
</style>
<style>
  .slide-left-enter-active,.slide-right-enter-active,.slide-left-leave-active,.slide-right-leave-active{
    transition: all 0.5s;
    transform: translateX(0);
  }
  .slide-left-enter,.slide-right-leave-to{
    transform: translateX(100%);
    transition: all 0.5s;
  }
  .slide-left-leave-to ,.slide-right-enter{
    transform: translateX(-100%);
    transition: all 0.5s;
  }
  .borderOnePx:after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #000;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 200%;
    height: 200%;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: left top;
    transform-origin: left top;
  }
  .onLinepx:after{
    content: '';
    position: absolute;
    bottom: -1px;
    background: #DCDCDC;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  .toastIndex {
  z-index: 100000001 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue